<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <!-- Admin -->
      <div class="grid_menu mb-5 pl-2" v-if="$store.state.status === 1">
        <!-- ประวัติการนับสต๊อก -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 0 || $store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 1 || $store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/count_stock/historylist">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/historylist">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <!-- อัพโหลดไฟล์บาร์โค้ด -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_barcode === 1">
          <router-link class="menu_team_link" to="/count_stock/uploadbarcode">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              อัพโหลดไฟล์บาร์โค้ด
            </div>
          </router-link>
        </v-card>
        <!-- สร้างรอบนับ -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_create === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/count_stock/countcreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/countcreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <!-- นับสต๊อก -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_count === 1 && data_stock.stock_status === 0">
          <router-link class="menu_team_link" to="/count_stock/countstock">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/countstock">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
      </div>
      <!-- Employee -->
      <div class="grid_menu mb-5 pl-2" v-else>
        <!-- ประวัติการนับสต๊อก -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 0 || $store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 1 || $store.state.userDetail.manage_stock === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/count_stock/historylist">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="d-none menu_team text-center mr-1 ml-1" v-else-if="$store.state.userDetail.manage_stock === 0">
          <router-link class="menu_team_link" to="/count_stock/historylist">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/historylist">
            <div class="menu_team_img">
              <img src="@/assets/supply.png">
            </div>
            <div>
              ประวัติการนับสต๊อก
            </div>
          </router-link>
        </v-card>
        <!-- อัพโหลดไฟล์บาร์โค้ด -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_barcode === 1">
          <router-link class="menu_team_link" to="/count_stock/uploadbarcode">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              อัพโหลดไฟล์บาร์โค้ด
            </div>
          </router-link>
        </v-card>
        <v-card class="d-none menu_team text-center mr-1 ml-1" v-else-if="$store.state.userDetail.manage_stock_barcode === 0">
          <router-link class="menu_team_link" to="/count_stock/uploadbarcode">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              อัพโหลดไฟล์บาร์โค้ด
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/uploadbarcode">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              อัพโหลดไฟล์บาร์โค้ด
            </div>
          </router-link>
        </v-card>
        <!-- สร้างรอบนับ -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_create === 1 && data_stock.stock_status === 2">
          <router-link class="menu_team_link" to="/count_stock/countcreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="d-none menu_team text-center mr-1 ml-1" v-else-if="$store.state.userDetail.manage_stock_create === 0">
          <router-link class="menu_team_link" to="/count_stock/countcreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-else disabled>
          <router-link class="menu_team_link" to="/count_stock/countcreate">
            <div class="menu_team_img">
              <img src="@/assets/clipboard_1.png">
            </div>
            <div>
              สร้างรอบนับ
            </div>
          </router-link>
        </v-card>
        <!-- นับสต๊อก -->
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_count === 1 && data_stock.stock_status !== 1 && data_stock.stock_status !== 2">
          <router-link class="menu_team_link" to="/count_stock/countstock">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
        <v-card class="menu_team text-center mr-1 ml-1" v-if="$store.state.userDetail.manage_stock_count === 1 && data_stock.stock_status !== 0" disabled>
          <router-link class="menu_team_link" to="/count_stock/countstock">
            <div class="menu_team_img">
              <img src="@/assets/find.png">
            </div>
            <div>
              นับสต๊อก
            </div>
          </router-link>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "MenuCount_Stock",
  data() {
    return {
      data_stock: [],
      loading_page: false,
    }
  },
  methods: {
    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit('logout_success')
        this.$router.push('/login')
      }
    },
    async check_loaded() {
      const config = {headers: {"Authorization": `Bearer ${this.$store.state.token}`}}
      await HTTP.post('/profile', {
        username: this.$store.state.user_data.username,
        password: this.$store.state.user_data.password
      }, config).then((res) => {
        this.$store.state.userDetail = res.data
      })
    },
    async checkStock() {
      this.loading_page = true
      this.data_stock = []
      await HTTP.post('/stocks/stocklatest')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              if (res.data.object == null) {
                const val = {
                  stock_status: 2
                }
                this.data_stock = val
                if (this.$store.state.userDetail.manage_stock === 0) {
                  if (this.$store.state.userDetail.manage_stock_create === 1) {
                    this.$router.push('/count_stock/countcreate')
                  }
                  else if (this.$store.state.userDetail.manage_stock_barcode === 1) {
                    this.$router.push('/count_stock/uploadbarcode')
                  }
                  else if (this.$store.state.userDetail.manage_stock_count === 1 && this.data_stock.stock_status === 0) {
                    this.$router.push('/count_stock/countstock')
                  }
                  else {
                    this.$router.push('/stock')
                  }
                }
                else if (this.$store.state.userDetail.manage_stock === 1) {
                  if (this.$route.path == '/count_stock/countstock' && this.data_stock.stock_status !== 0) {
                    this.$router.push('/count_stock/historylist')
                  }
                  else if (this.$route.path == '/count_stock/countcreate' && this.data_stock.stock_status !== 2) {
                    this.$router.push('/count_stock/historylist')
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_barcode === 0) {
                  if (this.$route.path == '/count_stock/uploadbarcode') {
                    this.$router.push('/count_stock/historylist')
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_count === 0) {
                  if (this.$route.path == '/count_stock/countstock') {
                    this.$router.push('/count_stock/historylist')
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_create === 0) {
                  if (this.$route.path == '/count_stock/countcreate') {
                    this.$router.push('/count_stock/historylist')
                  }
                }
              }
              else {
                this.data_stock = res.data.object;
                // catch สิทธิการใช้งานเมนู
                if (this.$store.state.userDetail.manage_stock === 0) {
                  if (this.$route.path == '/count_stock/historylist') {
                    if (this.$store.state.userDetail.manage_stock_create === 1 && this.data_stock.stock_status === 2) {
                      this.$router.push('/count_stock/countcreate')
                    }
                    else if (this.$store.state.userDetail.manage_stock_count === 1 && this.data_stock.stock_status === 0) {
                      this.$router.push('/count_stock/countstock')
                    }
                    else if (this.$store.state.userDetail.manage_stock_barcode === 1) {
                      this.$router.push('/count_stock/uploadbarcode')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                  else if (this.$route.path == '/count_stock/uploadbarcode') {
                    if (this.$store.state.userDetail.manage_stock_barcode === 1) {
                      this.$router.push('/count_stock/uploadbarcode')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                  else if (this.$route.path == '/count_stock/countcreate') {
                    if (this.$store.state.userDetail.manage_stock_create === 1 && this.data_stock.stock_status === 2) {
                      this.$router.push('/count_stock/countcreate')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                  else if (this.$route.path == '/count_stock/countstock') {
                    if (this.$store.state.userDetail.manage_stock_count === 1 && this.data_stock.stock_status === 0) {
                      this.$router.push('/count_stock/countstock')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
                else if (this.$store.state.userDetail.manage_stock === 1) {
                  if (this.$route.path == '/count_stock/countstock' && this.data_stock.stock_status !== 0) {
                    this.$router.push('/count_stock/historylist')
                  }
                  else if (this.$route.path == '/count_stock/countcreate' && this.data_stock.stock_status !== 2) {
                    this.$router.push('/count_stock/historylist')
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_barcode === 0) {
                  if (this.$route.path == '/count_stock/uploadbarcode') {
                    if (this.$store.state.userDetail.manage_stock !== 0) {
                      this.$router.push('/count_stock/historylist')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_count === 0) {
                  if (this.$route.path == '/count_stock/countstock') {
                    if (this.$store.state.userDetail.manage_stock !== 0) {
                      this.$router.push('/count_stock/historylist')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
                else if (this.$store.state.userDetail.manage_stock_create === 0) {
                  if (this.$route.path == '/count_stock/countcreate') {
                    if (this.$store.state.userDetail.manage_stock !== 0) {
                      this.$router.push('/count_stock/historylist')
                    }
                    else {
                      this.$router.push('/stock')
                    }
                  }
                }
              }
            }
          })
    },
  },
  beforeMount() {
    this.checkLogIn()
    this.check_loaded();
  },
  mounted() {
    this.checkStock();
  },
}
</script>

<style scoped>
.grid_menu {
  display: flex;
  justify-content: space-evenly;
}
@media only screen and (max-width: 1000px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 33.33% 33.33% 33.33%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 750px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
.menu_team{
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
</style>
